import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { asyncConnect } from 'react-async-client';
import { path, head, equals, map } from 'ramda';
import { translate } from 'react-translate-component';
import { Button } from 'antd';
import moment from 'moment';
import Translate from 'react-translate-component';
import { FormSpy } from 'react-final-form';
import * as yup from 'yup';

import { updateEvent } from 'actions/asyncActions';
import { DATE_FORMATS } from 'constants/dateFormats';
import EventFields from './EventFields';
import withFormWrapper from 'components/hocs/withFormWrapper';
import ListenerField from 'components/common/form/ListenerField'

const getId = (type, obj) => path([type, '0', 'id'], obj);

const stateToProps = (state, { item: { id, type, details = {}, comment }}) => ({
    initialValues: {
        id,
        contact: {
            type,
            project: getId('project', details),
            person: getId('people', details),
            employee: getId('responsible', details),
            contact: getId('contact', details),
            organization: getId('company', details),
            description: comment
        },
        details: {
            dateTo: details.eventDate,
            time: {
                from: path(['eventTime', 'from'], details),
                to: path(['eventTime', 'to'], details)
            },
            shortResult: undefined,
        },
        additionalPeople: map(participant => ({
            peopleId: participant.id,
            ...participant
        }), details.participants || [])
    }
});

const daysAllowed = (date, model, { item, initialValues }) => {
    const delta = path(['edit', 'allowedDaysDelta'], item) || 0;
    const maxBeforeDate = moment(initialValues.details.dateTo, DATE_FORMATS.format).subtract(delta, 'days');
    const maxAfterDate = moment(initialValues.details.dateTo, DATE_FORMATS.format).add(delta, 'days');
    const selectedDate = moment(date, DATE_FORMATS.format);

    return delta && !selectedDate.isBetween(maxBeforeDate, maxAfterDate, 'day', '[]') ?
        <Translate content="errors.dateNotAllowed" with={{ count: delta }} /> : undefined;
};

const moreThenTimeFrom = (time, model) => {
    const timeFrom = path(['details', 'time', 'from'], model);
    return moment(time, DATE_FORMATS.timeFormat).isBefore(moment(timeFrom, DATE_FORMATS.timeFormat)) ?
        <Translate content="errors.lessThanStartTime" /> : undefined;
};

const validationSchema = () => {
    return yup.object().shape({
        details: yup.object().shape({
            dateTo: yup.string().required('enterDate')
        })
    });
};

@asyncConnect({
    formAction: updateEvent
        .withParams(({ item }) => ({ id: item.id }))
        .withSuccessHandler(({ close }) => {
            close();
        })
        .withOptions({ autoReset: true }),
}, stateToProps)
@withFormWrapper({
    mapPropsToValues: props => props.initialValues,
    validationSchema
})
export default class EventEditForm extends Component {
    static propTypes = {
        close: PropTypes.func.isRequired,
        item: PropTypes.object.isRequired,
        formAction: PropTypes.object.isRequired,
        form: PropTypes.object,
        handleSubmit: PropTypes.func,
        initialValues: PropTypes.object
    };

    isDateEditable() {
        const edit = path(['item', 'edit'], this.props);

        return !edit || (
            edit.allowedChangeCount ? edit.changedCount < edit.allowedChangeCount : true
        );
    }

    handleSubmit = (e, values) => {
        const { close, initialValues, handleSubmit } = this.props;

        if (equals(values, initialValues)) {
            close();
        } else {
            handleSubmit(e);
        }
    }

    render() {
        const { close, item, form, formAction: { meta }, initialValues } = this.props;
        const onlyDateEditable = path(['item', 'edit', 'onlyDateEditable'], this.props);
        const { people = [], project = [], participants = [], xmltype } = path(['item', 'details'], this.props) || {};

        const eventDateProps = {
            disabledDateTo:  !this.isDateEditable(),
            validateDateTo: (value, all) => daysAllowed(value, all, { item, initialValues }),
            validateTimeTo: moreThenTimeFrom,
            onlyDateEditable: onlyDateEditable
        };

        return (
            <div className='panel-view'>
                <ListenerField
                    listenFieldName={[
                        'contact.organization',
                    ]}
                >
                    { ({ contact }) => (
                            <EventFields
                                person={head(people)}
                                project={head(project)}
                                participators={participants}
                                eventDateProps={eventDateProps}
                                change={form.change}
                                eventConfig={item.view}
                                isEdit={true}
                                organization={contact.organization}
                                eventId={initialValues.id}
                                xmlType={xmltype}
                            />
                        )
                    }
                </ListenerField>
                <div>
                    <FormSpy subscription={{ values: true }}>
                        { (values) => (
                            <Button onClick={e => this.handleSubmit(e, values)} disabled={meta.pending} type='primary'>
                                { translate('events.save') }
                            </Button>
                        )}
                    </FormSpy>
                    <Button className='card-button close-button' onClick={close}>
                        { translate('events.cancel') }
                    </Button>
                </div>
            </div>
        );
    }
}
